export const isValidPostalCodeFormat = (postalCode: string | undefined) => {
	return postalCode !== undefined && (isValidUsMexicoPostalCode(postalCode) || isValidCanadianPostalCode(postalCode));
};

const isValidUsMexicoPostalCode = (postalCode: string) => postalCode.match(/\d{5}-?(\d{4})?/) !== null;

const isValidCanadianPostalCode = (postalCode: string) =>
	postalCode.match(/[A-Z][0-9][A-Z]\s?[0-9][A-Z][0-9]/) !== null;
